<template>
  <v-autocomplete
    :value="value"
    :disabled="!items || $attrs.disabled || !site"
    :items="items"
    :label="displayLabel"
    item-text="startTime"
    item-value="id"
    @change="select"
    return-object
    v-bind="$attrs"
    :rules="[rules.required]"
  >
    <template v-slot:selection="data">
      <span v-if="onlyStart"> von&nbsp;</span>
      <span v-if="!onlyEnd">
        {{ data.item.startTime }}
      </span>
      <span v-if="!onlyEnd && !onlyStart">&nbsp;–&nbsp;</span>
      <span v-if="onlyEnd"> bis&nbsp;</span>
      <span v-if="!onlyStart">{{ data.item.endTime }}</span>
    </template>
    <template v-slot:item="data">
      <span v-if="onlyStart"> von&nbsp;</span>
      <span v-if="!onlyEnd">
        {{ data.item.startTime }}
      </span>
      <span v-if="!onlyEnd && !onlyStart">&nbsp;–&nbsp;</span>
      <span v-if="onlyEnd">bis&nbsp;</span>
      <span v-if="!onlyStart">{{ data.item.endTime }}</span>
    </template>
  </v-autocomplete>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "PeriodInput",
  props: {
    value: { type: Object, default: null },
    label: { type: String, default: "Lektion" },
    onlyStart: { type: Boolean, default: false },
    onlyEnd: { type: Boolean, default: false },
    site: { type: Object, default: null },
    required: { type: Boolean, default: false },
  },
  data() {
    return {
      items: [],
      sites: [],
      rules: {
        required: (value) => !!value || !this.required || "wird benötigt.",
      },
    };
  },
  computed: {
    displayLabel() {
      if (!this.site) {
        return this.label + " (bitte Standort wählen)";
      }
      return this.label + (this.site ? ` (${this.site.description})` : "");
    },
  },
  watch: {
    site() {
      if (this.site) {
        this.fetchData();
      } else {
        this.items = [];
      }
    },
  },
  methods: {
    async fetchData() {
      this.items = await this.apiList({
        resource: "common/period",
        query: `site=${this.site ? this.site.id : 1}`,
      });
    },
    select($event) {
      this.$emit("input", $event);
    },
  },
  async created() {
    this.fetchData();
  },
});
</script>
